import { bool } from "prop-types";

import FnrTypography from "UI/FnrTypography";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import {
  useAccentColor,
  useButtonTextColor,
  useIsLegacy,
} from "Login/TwoFA/stateHooks";

import FnrButton from "UI/FnrButton3/FnrButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

const NextButton = ({ isLoading }) => {
  const { firstFactor } = useTwoFAContext();
  const isDisabled = !firstFactor;
  const isLegacy = useIsLegacy();
  const accentColor = useAccentColor();
  const buttonTextColor = useButtonTextColor();

  return (
    <FnrHorizontalGap justifyContent="flex-end">
      <FnrButton
        loading={isLoading}
        disabled={isDisabled}
        color={isDisabled ? "grey" : accentColor}
      >
        <FnrHorizontalGap gap={8}>
          <FnrTypography
            type={isLegacy ? undefined : "accent"}
            bold={false}
            color={isDisabled ? buttonTextColor : "textLight"}
          >
            Next
          </FnrTypography>
          <FnrContainedIcon
            noPadding
            color={buttonTextColor}
            icon="fa-chevron-right fas"
          />
        </FnrHorizontalGap>
      </FnrButton>
    </FnrHorizontalGap>
  );
};

NextButton.propTypes = {
  isLoading: bool,
};

export default NextButton;
